import { CREATE_TDS_SECTION, GET_TDS_SECTION, TDS_SECTION_REQUEST, DELETE_TDS_SECTION, UPDATE_TDS_SECTION, TDS_SECTION_REQUEST_FAILURE } from "../types";

const initialState = {
  tdsSections: [],
  loading: false,
  error: null,
};

const tdsSectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TDS_SECTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_TDS_SECTION: {
      return {
        ...state,
        tdsSections: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_TDS_SECTION:
      return {
        ...state,
        tdsSections: [action.payload, ...state.tdsSections],
        loading: false,
        error: null
      };
    case UPDATE_TDS_SECTION:
      const tdsSectionsData = state.tdsSections.slice(0);
      const uIndex = tdsSectionsData.findIndex((data) => data.id === action.payload.id);
      tdsSectionsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        tdsSections: [ ...tdsSectionsData ],
        loading: false,
        error: null
      };
    case DELETE_TDS_SECTION:
      const tdsSections = state.tdsSections?.slice(0);
      const index = tdsSections.findIndex((data) => data.id === action.id);
      if (index > -1) {
          tdsSections.splice(index, 1);
      }
      return {
        ...state,
        tdsSections: [...tdsSections],
        loading: false,
        error: null
      }
    case TDS_SECTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default tdsSectionReducer